import { getCurrentInstance, computed } from 'vue';
import getDashedTitle from '@/utilities/getDashedTitle';
import { Page } from '@superthread-com/api';

export default function useOpenPage() {
  const _this = getCurrentInstance()?.proxy;
  if (!_this) return;
  const teamSlug = computed((): string => {
    return _this?.$store.getters.getTeamSlug;
  });

  const openPage = (page: Page) => {
    const baseRoute = `/${teamSlug.value}/page-${page.id}`;
    let route = baseRoute;
    if (page.title) {
      const dashedTitle = getDashedTitle(page.title);
      route = `${baseRoute}-${dashedTitle}`;
    }

    if (_this.$route.path === route) return;

    _this.$store.dispatch('setPage', page);
    _this.$store.dispatch('setNewPageCreating', false);
    _this.$router.push(route);
    _this.$store.dispatch('setCurrentProjectId', page.project_id);
  };

  return {
    openPage,
  };
}
